export default __webpack_public_path__ + "static/media/DH_printing_rules_mm.b21647b6.pdf";